import { render, staticRenderFns } from "./MmmFlatButton.vue?vue&type=template&id=de3ab1da&"
import script from "./MmmFlatButton.vue?vue&type=script&lang=js&"
export * from "./MmmFlatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QTooltip})
